import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { FontAwesome } from 'components/ui';
import { LEGACY_URL } from 'components/constants';
// components
import { Col } from 'reactstrap';

export class QuickLinks extends Component {

  static defaultProps = {
    beta: false
  }

  render() {
    const { isCamp } = this.props;
    return (
      <Col xs={12} sm={6} xl={4}>
        <div id='QuickLinks' className='widget'>
          <h2>Quick Links</h2>

          <div id='links'>
            { !isCamp && <Link to='/missions/print'>
              <FontAwesome icon='print' />
              Print Missions
            </Link> }
            <Link to='/missions/mark'>
              <FontAwesome icon='check-circle' regular />
              Mark Missions
            </Link>
            { isCamp && <a href={`${LEGACY_URL}/pesukim/marking/daily_marking.php`}>
              <FontAwesome icon='star' />
              Mark 12 Pesukim
            </a> }
            {/* <a href={`${LEGACY_URL}/api/beta`}>
              <FontAwesome icon='door-open' />
              { this.props.beta ? 'Join' : 'Leave' } Beta
            </a> */}
          </div>
        </div>
      </Col>
    );
  }
}

export class Resources extends Component {

  render() {
    return (
      <Col xs={{ size: 12, order: 12 }} xl={{ size: 4, order: 0 }}>
        <div id='Resources' className='widget'>
          <h2>Resources</h2>

          <div id='links'>
            <a href='/resources' target='_blank' rel="noopener noreferrer">
              <img src={`${LEGACY_URL}/homeIcons/dropbox.svg`} alt='hachayol'/>
              Resources
            </a>
            <a href='//dropbox.com/sh/41u2regs73kfp9h/AACJV58J9KD6elXXZisYz74Ia?dl=0' target='_blank' rel="noopener noreferrer">
              <img src={`${LEGACY_URL}/homeIcons/tanya.png`} alt='tanya'/>
              Tanya
            </a>
            <a href='//thechidon.com' target='_blank' rel="noopener noreferrer">
              <img src={`${LEGACY_URL}/homeIcons/Chidon.png`} alt='chidon'/>
              Yahadus
            </a>
          </div>
        </div>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/widgets/QuickLinks.jsx